import React, { useState } from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import EditLeadTypeConversion from '../../components/version-4/MasterForms/EditForms/EditLeadTypeConversion'
import { useLeadTypeConversion } from '../../hooks/CompanyConfiguration/useLeadTypeConversion'
import { ROUTES } from '../../shared/constants'
import AddLeadTypeConversion from './AddLeadTypeConversion'

function EditLeadTypeConvert() {
  const { getLeadTypeConversion, leadTypeConversion, addLeadTypeConversion } = useLeadTypeConversion()
  const params = useParams()

  const [leadTypeConversionData, setLeadTypeConversionData] = useState({
    convertFrom: {},
    convertTo: {},
    convertDuration: null,
    convertLeadTypeId: params.convertLeadTypeId,
  })

  const handleLeadTypeConversion = () => {
    addLeadTypeConversion(leadTypeConversionData)
  }

  React.useEffect(() => {
    getLeadTypeConversion({ convertLeadTypeId: params.convertLeadTypeId })
  }, [params.convertLeadTypeId])

  React.useEffect(() => {
    setLeadTypeConversionData({
      convertFrom: leadTypeConversion.convertFrom ? leadTypeConversion.convertFrom.name : '',
      convertTo: leadTypeConversion.convertTo ? leadTypeConversion.convertTo.name : '',
      convertDuration: leadTypeConversion.convertDuration,
      convertLeadTypeId: params.convertLeadTypeId,
    })
  }, [leadTypeConversion])

  return (
    <>{leadTypeConversion ? <AddLeadTypeConversion leadTypeConversion={leadTypeConversion} /> : <Loader />}</>
    // <Layout heading="Lead Type Conversion" heading2="Edit" url1={ROUTES.LEADTYPE_CONVERSION} none>
    //   {leadTypeConversion ? (

    //   ) : (
    //     <Loader />
    //   )}
    // </Layout>
  )
}

export default EditLeadTypeConvert
